import Heading from "@/modules/settings/components/Heading";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { Link, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import PageTransition from '@/components/module/admin/layout/PageTransition';
interface SettingsLayoutProps {
  children: ReactNode;
}

const sidebarNavItems = [
  { title: "Profile", href: "/profile", icon: null },
  { title: "Password", href: "/password", icon: null },
  { title: "Appearance", href: "/appearance", icon: null },
];

export default function SettingsLayout({ children }: SettingsLayoutProps) {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <PageTransition>
      <div className="px-4 py-6">
        <Heading
          title="Settings"
          description="Manage your profile and account settings"
        />

        <div className="flex flex-col lg:flex-row lg:space-x-12">
          <aside className="w-full max-w-xl lg:w-48">
            <nav className="flex flex-col space-y-1 space-x-0">
              {sidebarNavItems.map((item, index) => (
                <Button
                  key={`${item.href}-${index}`}
                  size="sm"
                  variant="ghost"
                  asChild
                  className={cn("w-full justify-start", {
                    "bg-muted": currentPath.startsWith(item.href),
                  })}
                >
                  <Link to={item.href}>{item.title}</Link>
                </Button>
              ))}
            </nav>
          </aside>

          <Separator className="my-6 lg:hidden" />

          <div className="flex-1 md:max-w-2xl">
            <section className="max-w-xl space-y-12">{children}</section>
          </div>
        </div>
      </div>
      </PageTransition>
  );
}
